import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNoFlash: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconNoFlash"><Path d="M16.5142 15.0218L21.7484 19.6902L20.75 20.8096L2.25 4.30963L3.24842 3.19019L8.38739 7.77359L14.0019 0.238281V8.00013H21.7461L16.5142 15.0218Z" fill="currentColor"/><Path d="M2.25781 16.0001L6.58889 10.1874L14.7157 17.4356L10.0019 23.762V16.0001H2.25781Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNoFlash;
